import React from "react"
import { NextSeo } from "next-seo"
import { withRouter } from "next/router"

import Home from "~/components/careers/Home"

const CareersPage = () => {
  return (
    <>
      <NextSeo
        title="Careers at WinIt"
        description="Join the team that powers NYC's #1 app for fighting tickets"
        canonical="https://www.appwinit.com/careers"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Join the team that powers NYC's #1 app for fighting tickets",
          },
        ]}
      />
      <Home />
    </>
  )
}

export default withRouter(CareersPage)
